import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { PAID_COLUMN, PURCHASES_PAID_MODULE, TOURIST_PAID_COLUMN } from "../constant/purchasesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const paidColumns = (): Column[] => subDomain === 'tourist-forum' ? TOURIST_PAID_COLUMN : PAID_COLUMN;

export const setPurchasesReceiptPaidPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: PURCHASES_PAID_MODULE,
        default_columns: paidColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
